import React, { ChangeEvent } from "react";
import styled from "styled-components";
import {
  ColumnContainer,
  FlexibleContainer,
  RowContainer,
} from "../containers/styledComponents";
import {
  CompassParagraph,
  CompassInput,
  CompassTextarea,
  TextBox,
} from "./styledComponents";
import { lightGreys } from "../../styles";

const InputBox = styled(CompassInput)<{ mr?: number }>`
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
  padding: 10px; 15px;
  border-radius: 8px;
  border: 1px solid ${lightGreys.borderLightGrey};
  margin-right: ${({ mr }): number => (mr ? mr : 0)}px;
  `;

const TextArea = styled(CompassTextarea)``;

enum InputType {
  None,
  TextArea,
  InputBox,
}

export const ContentBox = ({
  title,
  content,
  inputProps,
  isLoading = false,
  mr = 15,
}: ContentBoxProps): JSX.Element => {
  // Determine the input type
  const inputType: InputType = inputProps
    ? inputProps.isTextArea
      ? InputType.TextArea
      : InputType.InputBox
    : InputType.None;

  const renderContent = (isLoading: boolean): JSX.Element => {
    if (isLoading) {
      return (
        <TextBox isLoading={isLoading} mr={mr}>
          <CompassParagraph>{content}</CompassParagraph>
        </TextBox>
      );
    }
    switch (inputType) {
      case InputType.TextArea:
        return (
          <TextArea
            value={content}
            onChange={(e): void => inputProps?.onChange(e as Event, "content")}
          />
        );
      case InputType.InputBox:
        return (
          <InputBox
            mr={mr}
            value={content}
            onChange={(e): void => inputProps?.onChange(e as Event, "title")}
          />
        );
      default:
        return (
          <TextBox isLoading={isLoading} mr={mr}>
            <CompassParagraph>{content}</CompassParagraph>
          </TextBox>
        );
    }
  };

  return (
    <ColumnContainer mt={1}>
      <RowContainer mb={1}>
        <FlexibleContainer ml={"5px"}>
          <CompassParagraph bold={true}>{title}</CompassParagraph>
        </FlexibleContainer>
      </RowContainer>
      <RowContainer mb={1} mt={3}>
        {renderContent(isLoading)}
      </RowContainer>
    </ColumnContainer>
  );
};

type ContentBoxProps = {
  title: string;
  content: string;
  inputProps?: InputProps;
  isLoading?: boolean;
  mr?: number;
};

export interface Content {
  title: string;
  content: string;
}

export type InputProps = {
  onChange: InputChangeFunc | TextAreaChangeFunc;
  isTextArea: boolean;
};

type InputChangeFunc = (
  e: React.ChangeEvent<HTMLInputElement>,
  source: "title" | "content"
) => void;
type TextAreaChangeFunc = (
  e: React.ChangeEvent<HTMLTextAreaElement>,
  source: "title" | "content"
) => void;
type Event = ChangeEvent<HTMLInputElement> & ChangeEvent<HTMLTextAreaElement>;
